export enum VCircleProgressBarSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum VCircleProgressBarVariant {
  IN_PROGRESS = 'inProgress',
  COMPLETED = 'completed',
  ERROR_DANGER = 'errorDanger',
}

export const VCircleProgressBarWidth = {
  [VCircleProgressBarSize.SMALL]: 56,
  [VCircleProgressBarSize.MEDIUM]: 80,
} as const;

export const VCircleProgressBarBorderWidth = {
  [VCircleProgressBarSize.SMALL]: 5.5,
  [VCircleProgressBarSize.MEDIUM]: 4,
} as const;
